module.exports = {
  topbar: false,
  appName: 'Litafl',
  games: ['tafl'],
  sideNames: {
    tafl: {
      a: 'attacker',
      r: 'random',
      d: 'defender',
    },
    pentago: {
      w: 'white',
      r: 'random',
      b: 'black',
    },
  },
  types: {
    bullet: {
      icon: 'fad fa-bolt',
      colorPrimary: 'orange',
      colorSecondary: 'orange',
      desc: '<3 minutes',
    },
    blitz: {
      icon: 'fad fa-fire',
      colorPrimary: 'orangered',
      colorSecondary: 'orangered',
      desc: '3-8 minutes',
    },
    rapid: {
      icon: 'fad fa-rabbit-fast',
      colorPrimary: '#333',
      colorSecondary: 'gray',
      desc: '8-25 minutes',
    },
    classical: {
      icon: 'fad fa-turtle',
      colorPrimary: 'green',
      colorSecondary: '#333',
      desc: '25+ minutes',
    },
    // correspondence: {
    //   icon: 'fad fa-user-friends',
    //   colorPrimary: '#777',
    //   colorSecondary: '#777',
    //   desc: '1 day',
    // },
    _: {},
  },
};
